export enum CameraProfileTarget {
  Area,
  Item,
}
